module.exports = __webpack_public_path__ + "media/fyt_m23.50a436d0.mp4";